import React from 'react';

import icon1 from '../images/icon_video.svg'

const ComoLoHacemos = (props) => {
  return (
    <div>
    	<div className="HomeWrapper" style={{background: '#f6f6f6'}}>
            <div className="ContentsContainer IndexHacemos">
                <h2>Cómo lo hacemos</h2>
                <p>1 llamada, 2 días de trabajo y 1 reunión para mostrarle cómo se vera su producto. Es todo lo que necesitamos para hacer proyectos increibes y escalabes.</p>
                <ul>
                    <li>
                        <figure><img src={icon1} alt=""/></figure>
                        <h3>Planeamos</h3>
                        <p>Estudiamos su idea desde todos los ángulos y llevamos a cabo estudios de mercado para imaginar cómo se veran, probarán y lanzaran.</p>
                    </li>
                    <li>
                        <figure><img src={icon1} alt=""/></figure>
                        <h3>rayamos</h3>
                        <p>Nuestros diseñadores luego dibujarán, dibujarán y diseñarán su idea, probando todos los aspectos de su usabilidad y simpatía.</p>
                    </li>
                    <li>
                        <figure><img src={icon1} alt=""/></figure>
                        <h3>A rodar</h3>
                        <p>Estamos listos para implementar un equipo cuidadosamente seleccionado para construir la mejor versión de su producto digital de la manera más eficiente.</p>
                    </li>
                </ul>

            </div>
        </div>
    </div>
  )
}

export default ComoLoHacemos;


// WEBPACK FOOTER //
// ./src/components/comolohacemos.js